/* หน้าสินค้า — สลับรูปใน gallery */
(function () {
  "use strict";
  function init() {
    var main = document.getElementById("sdspMain");
    var thumbs = document.querySelectorAll(".sdsp-thumb");
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        var full = t.getAttribute("data-full");
        if (!full) return;
        var srcset = t.getAttribute("data-srcset");
        if (srcset) main.srcset = srcset;
        else main.removeAttribute("srcset");
        main.src = full;
        thumbs.forEach(function (x) { x.classList.remove("is-on"); });
        t.classList.add("is-on");
      });
    });
  }
  /* แถบซื้อติดขอบล่าง — โผล่เมื่อปุ่มใส่ตะกร้าหลักไม่อยู่บนจอ (CSS แสดงเฉพาะมือถือ) */
  var stickyObserver;
  function initSticky() {
    var bar = document.getElementById("sdspSticky");
    var mainBtn = document.querySelector("#sdspForm [name='add']");
    if (stickyObserver) stickyObserver.disconnect();
    if (!bar || !mainBtn || !("IntersectionObserver" in window)) return;
    var mobile = window.matchMedia("(max-width: 749px)");
    stickyObserver = new IntersectionObserver(function (entries) {
      var show = !entries[0].isIntersecting;
      bar.hidden = !show;
      document.body.classList.toggle("sdsp-sticky-on", show && mobile.matches);
    });
    stickyObserver.observe(mainBtn);
  }
  function boot() { init(); initSticky(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
